var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:_vm.gaugeColor},_vm._l((10),function(index){return _c('div',{key:'bar_' + index,staticClass:"bar",class:{'active' : _vm.value>=index}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }